import { all, put, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import {
  FETCH_ALL_USERS_REQUEST,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  SET_LOADING_STATE,
  RESET_LOADING_STATE
} from "../constants";
import { firebaseFetchAllUsers, firebaseEditUser } from "../api/api";

function* fetchAllUsersFn(): any {
  try {
    yield put({
      type: SET_LOADING_STATE
    })
    const response = yield firebaseFetchAllUsers();
    if (response) {
      yield put({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: { allUsers: response },
      });
      yield put({
        type: RESET_LOADING_STATE
      })
    } else {
      yield put({ type: FETCH_ALL_USERS_FAILURE });
      yield put({
        type: RESET_LOADING_STATE
      })
    }
  } catch (err) {
    yield put({ type: FETCH_ALL_USERS_FAILURE });
    yield put({
      type: RESET_LOADING_STATE
    })
  }
}

function* updateUserFn({ payload }: any): any {
  try {
    const response = yield firebaseEditUser(payload);
    if (response) {
      yield put({ type: UPDATE_USER_SUCCESS, payload: { allUsers: response } });
    } else {
      yield put({ type: UPDATE_USER_FAILURE });
    }
  } catch (err) {
    yield put({ type: UPDATE_USER_FAILURE });
  }
}

export default function* userSaga(): SagaIterator {
  yield all([
    takeEvery(FETCH_ALL_USERS_REQUEST, fetchAllUsersFn),
    takeEvery(UPDATE_USER_REQUEST, updateUserFn),
  ]);
}
